import { render } from "./CustomTextArea.vue?vue&type=template&id=2d8463e8&scoped=true&ts=true"
import script from "./CustomTextArea.vue?vue&type=script&lang=ts"
export * from "./CustomTextArea.vue?vue&type=script&lang=ts"

import "./CustomTextArea.vue?vue&type=style&index=0&id=2d8463e8&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8463e8"]])

export default __exports__